import { render, staticRenderFns } from "./ToastificationPosition.vue?vue&type=template&id=5af48eea&"
import script from "./ToastificationPosition.vue?vue&type=script&lang=js&"
export * from "./ToastificationPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports